// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"b91460c8","682":"5ce97870","687":"efac614c","836":"d9e4141e","924":"c9d52455","992":"26c85195"}[chunkId] + ".chunk.css";
};